module.exports = __webpack_public_path__ + "img/bunny-ears-3.79c1f75a.svg";